import { stringify } from 'query-string';

export const usersDataProvider = context => {
    const basePath = `${context.apiUrl}/v2/users`;

    return {
        getList: async ({
            filter = {},
            pagination = { page: 1, perPage: 12 },
            sort = null,
        }) => {
            const url = `${basePath}?${stringify({
                ...filter,
                offset:
                    pagination.page * pagination.perPage - pagination.perPage,
                limit: pagination.perPage,
                sortBy: 'username',
                sortOrder: sort.order,
                includeAnonymous: true,
            })}`;

            const roleNameMapping = {
                '00000005-0005-0005-0005-000000000005': 'Organization Admin',
                '00000006-0006-0006-0006-000000000006': 'Developer',
            };

            const { json } = await context.fetchJson(url, {
                credentials: 'include',
            });

            return {
                data:
                    json.list.map(({ uuid, ...item }) => ({
                        id: uuid,
                        role: roleNameMapping[item.access[0]?.roleUuid],
                        ...item,
                    })) || [],
                total: json.count || 0,
            };
        },

        getOne: async ({ id }) => {
            const url = `${basePath}/${id}`;

            const {
                json: { Uuid, ...data },
            } = await context.fetchJson(url, { credentials: 'include' });

            return {
                data: {
                    id: Uuid,
                    ...data,
                },
            };
        },

        create: async ({ data }) => {
            const url = `${basePath}?notifyUser=true`;
            data.authConfigUuid = 'DEFAULT';
            data.status = 'REGISTRATION_INIT';

            const {
                json: { Uuid, ...responseData },
            } = await context.fetchJson(url, {
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify(data),
            });

            return {
                data: {
                    id: Uuid,
                    name: responseData.Name,
                    status: responseData.Status,
                    organizationUuid: responseData.OrganizationUuid,
                    organizationName: responseData.OrganizationName,
                    apiIds: responseData.ApiIds,
                    apiApiPlanIds: responseData.ApiApiPlanIds,
                    apiGroupIds: responseData.ApiGroupIds,
                    apiKey: responseData.ApiKey,
                    keySecret: responseData.KeySecret,
                    disabledByType: responseData.DisabledByType,
                    ...responseData,
                },
            };
        },
        update: async ({ id, data }) => {
            const url = `${basePath}/${id}`;
            if( data.roleName)
                data?.access[0]?.roleUuid = data.roleName;
            const {
                json: { ...responseData },
            } = await context.fetchJson(url, {
                credentials: 'include',
                method: 'PUT',
                body: JSON.stringify(data),
            });

            return {
                data: {
                    id: responseData.Uuid,
                    name: responseData.Name,
                    description: responseData.Description,
                    status: responseData.Status,
                    organizationUuid: responseData.OrganizationUuid,
                    organizationName: responseData.OrganizationName,
                    apiIds: responseData.ApiIds,
                    apiApiPlanIds: responseData.ApiApiPlanIds,
                    apiGroupIds: responseData.ApiGroupIds,
                    apiKey: responseData.ApiKey,
                    keySecret: responseData.KeySecret,
                    disabledByType: responseData.DisabledByType,
                    ...responseData,
                },
            };
        },
        deleteMany: async ids => {
            const url = `${basePath}?uuids=${ids.ids}`;

            const response = await context.fetchJson(url, {
                credentials: 'include',
                method: 'DELETE',
            });

            return {
                data: [],
                status: response.status,
            };
        },
        delete: async ({ id }) => {
            const url = `${basePath}/${id}`;

            const {
                json: { ...data },
            } = await context.fetchJson(url, {
                credentials: 'include',
                method: 'DELETE',
            });

            return {
                data: { data },
            };
        },
    };
};
